<template>
  <div class="tabcontentdiv">
    <div class="text-block-2">{{ templateText }}</div>
    <div class="form-block w-form">
      <form @submit.prevent>
        <input
          v-model="searchString"
          type="text"
          class="text-field w-input"
          maxlength="256"
          name="name"
          data-name="Name"
          placeholder="Vorlage suchen"
        />
      </form>
    </div>
    <div style="width: 100%;">
      <group
        v-for="g of contractGroups"
        :key="g.id"
        :group="g"
        :contracts="queriedContracts"
        @sharePressed="insertContract"
      />
    </div>
    <loader v-if="contractLoader" />
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import Group from "@/components/Group";
import wordService from "@/service/wordService";
import groupmixin from "@/components/mixins/group.mixin";
import searchmixin from "@/components/mixins/search.mixin";
import HTTP from "@/service/httpservice";
const clauseDao = new HTTP("/search/clauses");
const contractDao = new HTTP("/search/contracts");
const documentDao = new HTTP("/document/base64");
export default {
  mixins: [groupmixin, searchmixin],
  components: { Group, Loader },
  data() {
    return {
      contracts: [],
      loading: false,
      contractLoader: false
    };
  },
  computed: {
    contractGroups() {
      return this.groups.filter(g => g.type === "CONTRACT");
    },
    templateText() {
      if (!this.loading) {
        return "Vorlagen";
      }
      return "Vorlagen (werden geladen...)";
    },
    queriedContracts() {
      return this.search(this.contracts, this.searchString).filter(
        c => !(c.isNda || c.isNdaCustomerEntity)
      );
    }
  },
  methods: {
    async insertContract(contract) {
      console.log(
        "Insert template " + contract.name + " " + contract.templatePath
      );
      const path = (contract.templatePath || "").toLowerCase();
      if (path.endsWith(".xlsx") || path.endsWith(".pptx")) {
        Office.context.ui.openBrowserWindow(contract.templatePath);
        return;
      }
      this.contractLoader = true;

      try {
        OfficeExtension.config.extendedErrorLogging = true;
        await Word.run(async context => {
          const oldOoxml = context.document.body.getOoxml();
          const base64Doc = await documentDao
            .get(contract.id)
            .then(res => res.data);
          window.analytics.track(
            "[ADD-IN] INSERT CONTRACT - " + contract.name,
            {
              id: contract.id,
              name: contract.name
            }
          );
          context.document.body.insertFileFromBase64(base64Doc, "Replace");
          await context.sync();
          const clauses = await clauseDao.get().then(res => res.data);
          await wordService.searchAndReplaceClauses(clauses);
          await context.sync();
          const newOoxml = context.document.body.getOoxml();
          const documentCreated = context.application.createDocument(base64Doc);
          console.log({ documentCreated });
          console.log("Try to insert ooxml");
          await context.sync();
          console.log(newOoxml);
          documentCreated.body.insertOoxml(newOoxml.value, "Replace");
          await context.sync();
          console.log("Inserted success, now open...");
          documentCreated.open();
          console.log("Opened....");
          context.document.body.insertOoxml(oldOoxml.value, "Replace");
          try {
            await context.sync();
          } catch (e) {
            console.error(e);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.contractLoader = false;
      }
    }
  },
  created() {
    this.loading = true;
    contractDao
      .get()
      .then(res => {
        this.contracts = res.data;
        this.loading = false;
      })
      .catch(e => {
        this.loading = false;
      });
  }
};
</script>



// WEBPACK FOOTER //
// src/ContractTab.vue